const drawerSelectors = {
  cartIconDesktop: document.querySelector('#cart-icon-desktop'),
  cartIconMobile: document.querySelector('#cart-icon-mobile'),
  cartTotal: document.querySelector('cart-form [data-cart-total]')
};

class AjaxCart extends HTMLElement {
    constructor() {
      super();
      this.cartForm = this.querySelector('form[data-cart-form]');
      this.cartDrawer = document.querySelector('#component-cart-drawer');
      this.sectionID = this.dataset.sectionId || 'component-cart-drawer';

      if(window.globalSpace.template == 'cart'){
        this.sectionID = this.dataset.sectionId || document.getElementById('cart--items')?.dataset.id;
        this.updateEvents();
      }else{
        this.getCartData();
      }

      this.cartForm.addEventListener('keydown', (e)=>{
        if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault();
        }
      });
      if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }

    /**
     * Observe attribute of component
     * 
     * @returns {array} Attributes to Observe
     */
    static get observedAttributes() {
      return ['updating'];
    }

    /**
     * bind Other inside element events to DOM
     */
    updateEvents(){
      this.cartForm.querySelectorAll('[data-item-remove]').forEach(button => button.addEventListener('click', this.removeItem.bind(this)));
      this.cartForm.querySelectorAll('[data-qty-input]').forEach(button => button.addEventListener('change', (evt)=>{
        this.onQtyChange(evt);
      }));
      this.manageGiftNoteForm();
    }

    manageGiftNoteForm(){
      const giftBoxNote = document.querySelector('[data-giftNote]');
      const giftToggleMsg1 = document.querySelector('[data-toggle-Msg1]');
      // const giftToggleMsg2 = document.querySelector('[data-toggle-Msg2]');
      document.addEventListener('change', (e) => {

        const currentTarget = e.target;
        
        if (currentTarget.hasAttribute('data-toggleNote')) {
          // alert('Gift Note is not available in this theme.');
          const giftNoteForm = currentTarget.closest('[data-updateGiftForm]');
          console.log(currentTarget.checked,'currentTarget.checked')
          if (currentTarget.checked) {
            giftNoteForm.querySelector('.add-message--block').style.display = 'block';
            // if (typeof(giftToggleMsg2) != 'undefined' && giftToggleMsg2 != null){
            //   giftToggleMsg2.style.display = 'block';
            // }
            // if (typeof(giftToggleMsg1) != 'undefined' && giftToggleMsg1 != null){
            //   giftToggleMsg1.style.display = 'none';
            // }
          } else {
            giftNoteForm.querySelector('.add-message--block').style.display = 'none';
            // if (typeof(giftToggleMsg1) != 'undefined' && giftToggleMsg1 != null){
            //   giftToggleMsg1.style.display = 'block';
            // }
            // if (typeof(giftToggleMsg2) != 'undefined' && giftToggleMsg2 != null){
            //   giftToggleMsg2.style.display = 'none';
            // }
            giftNoteForm.querySelector('[data-giftNote]').value = '';
            // if (window.globalVariables.giftMessagePresent == true) {
            //   this.updateGiftMessage(giftNoteForm,'2');
            // }
          }
        }
      })
    }
  
    /**
     * Open Cart drawer and add focus to drawer container
     */
    initCartDrawer(elementTofocus) {
      if(!window.globalSpace.cart_drawer){
        window.location.href = window.routes.cart_fetch_url || '/cart';
        return;
      }

      if(this.cartDrawer) this.cartDrawer.openDrawer(elementTofocus);
    }
  
     /**
     * Fetch latest cart data 
     */
     getCartData(){
      const cartRoute = `${window.location.pathname}?sections=${this.sectionID},header`;
      fetch(cartRoute).then(response => response.json()).then(response => {
          this._updateCart(response);
      }).catch((e) => {
          console.error(e);
      }).finally(() => {
          // Cart HTML fetch done
      });
    }

    /**
     * Update cart HTML and Trigger Open Drawer event
     *
     * @param {string} cartHTML String formatted response from fetch cart.js call
     * @param {HTML Node} openDrawerBtn open drawer node
     */
    _updateCart(response, openDrawerBtn = null){
      if(response === null) return;
      
      this.setAttribute('updating', true);

      let cartHTML = response[this.sectionID] || response['template-cart'];
      const parser = new DOMParser();
      cartHTML = parser.parseFromString(cartHTML, 'text/html');

      const cartJSONEle = cartHTML.querySelector('[data-cartScriptJSON]');
      window.globalSpace.cart = JSON.parse(cartJSONEle.textContent);

      const cartElement = cartHTML.querySelector('form');
      this.cartForm.innerHTML = cartElement.innerHTML;

      const newDiscountWrap = cartHTML.querySelector('[data-cart-drawer-discount]');
      const currentDiscountWrap = this.querySelector('[data-cart-drawer-discount]');
      if (newDiscountWrap && currentDiscountWrap) {
        currentDiscountWrap.replaceWith(document.importNode(newDiscountWrap, true));
      } else if (currentDiscountWrap) {
        currentDiscountWrap.classList.toggle('d-none', window.globalSpace.cart.item_count <= 0);
      }

      const cartTotal = Utility.formatMoney(window.globalSpace.cart.total_price, window.globalSpace.money_format);
      drawerSelectors.cartTotal.innerHTML = cartTotal;

      const cartItemsCount = cartHTML.querySelector('[data-item-count]');
      if(cartItemsCount) this.querySelector('[data-item-count]').innerHTML = cartItemsCount.innerHTML;
      if(this.cartDrawer){
        if(window.globalSpace.cart.item_count > 0){
          this.cartDrawer.querySelector('[data-cartupsell]').classList.remove('d-none');
          this.cartDrawer.querySelector('[data-updategiftform]').classList.remove('d-none');
        }else{
          this.cartDrawer.querySelector('[data-cartupsell]').classList.add('d-none');
          this.cartDrawer.querySelector('[data-updategiftform]').classList.add('d-none');
        }

      }

      const cartFormContainer = this.querySelector('.cart-form-container');
      (window.globalSpace.cart.item_count <= 0) ? cartFormContainer.classList.add('empty_cart') : cartFormContainer.classList.remove('empty_cart');

      const headerHTML = new DOMParser().parseFromString(response.header, 'text/html');
      const cartIcon = headerHTML.getElementById('cart-icon-mobile');
      if(drawerSelectors.cartIconDesktop && cartIcon) drawerSelectors.cartIconDesktop.innerHTML = cartIcon.innerHTML;
      if(drawerSelectors.cartIconMobile && cartIcon) drawerSelectors.cartIconMobile.innerHTML = cartIcon.innerHTML;

      this.updateEvents();
      window?.Shopify?.PaymentButton?.init();
      if(window.globalSpace.cart_drawer && openDrawerBtn){
        this.initCartDrawer(openDrawerBtn);
      }

      document.querySelectorAll("img[data-src], img[data-srcset], source[data-srcset]").forEach((e) => {
        const datasrcset = e.dataset.srcset;
        if(datasrcset != null) {
            e.srcset = datasrcset;
            e.removeAttribute('data-srcset');
        }

        const datasrc = e.dataset.src;
        if(datasrc != null) {
            e.src = datasrc;
            e.removeAttribute('data-src');
        }
      });

      this.setAttribute('updating', false);
    }

    /**
     * Update cart UI from section rendering response (discount apply/remove)
     *
     * @param {string} sectionHTML - Rendered section HTML from cart/update.js
     */
    _updateCartUI(sectionHTML) {
      if (!sectionHTML) return;

      this.setAttribute('updating', true);

      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHTML, 'text/html');

      const discountContainer = document.getElementById(`cart-discount-${this.sectionID}`);
      const newDiscountContainer = doc.getElementById(`cart-discount-${this.sectionID}`);
      if (discountContainer && newDiscountContainer) {
        discountContainer.replaceWith(document.importNode(newDiscountContainer, true));
      }

      const cartDiscount = this.querySelector('cart-discount');
      const newCartDiscount = doc.querySelector('cart-discount');
      if (cartDiscount && newCartDiscount) {
        cartDiscount.replaceWith(document.importNode(newCartDiscount, true));
      }

      const cartTotal = doc.querySelector('[data-cart-total]');
      const currentTotal = this.querySelector('[data-cart-total]');
      if (cartTotal && currentTotal) {
        currentTotal.innerHTML = cartTotal.innerHTML;
      } else if (window.globalSpace.cart && currentTotal) {
        currentTotal.innerHTML = Utility.formatMoney(window.globalSpace.cart.total_price, window.globalSpace.money_format);
      }

      const cartSubtotal = doc.querySelector('[data-cart-subtotal]');
      const currentSubtotal = this.querySelector('[data-cart-subtotal]');
      if (cartSubtotal && currentSubtotal) {
        currentSubtotal.innerHTML = cartSubtotal.innerHTML;
      }

      const cartJSONEle = doc.querySelector('[data-cartScriptJSON]');
      const currentJSON = this.querySelector('[data-cartScriptJSON]');
      if (cartJSONEle && currentJSON) {
        currentJSON.textContent = cartJSONEle.textContent;
        window.globalSpace.cart = JSON.parse(cartJSONEle.textContent);
      }

      document.dispatchEvent(new CustomEvent('cart:updated'));
      this.setAttribute('updating', false);
    }
  
     /**
     * Update Quantity API call 
     *
     * @param {string} line Line Index value of cart Item (Starts from 1)
     * @param {integer} quantity Quantity to update
     */
    updateItemQty(line, quantity){
      const lineItem = document.querySelectorAll('[data-cart-item]')[line-1];

      if(lineItem){ lineItem.classList.add('updating'); }
      const body = JSON.stringify({
        line,
        quantity,
        sections: `${this.sectionID},header`
      });

      fetch(`${routes.cart_change_url}`, { ...Utility.fetchConfig(), ...{ body }})
      .then((response) => response.text())
      .then((_state) => {
        const dataJSON = ((typeof _state == 'object') ? _state : JSON.parse(_state));
        if(dataJSON.errors){
          window.notificationEle.updateNotification('Cart Update', dataJSON.errors, {
            type: 'error',
            timeout: 5000
          });

          const cartItem = window.globalSpace.cart.items[line-1];
          const qtyInput = this.cartForm.querySelector(`input[data-qty-input][data-index="${line}"]`);
          if(qtyInput) qtyInput.value = cartItem.quantity;
          return;
        }

        eventBus.publish(PUB_SUB_EVENTS.cartUpdate, {
          data: {
            action: (quantity == 0) ? 'remove-item': 'update-qty',
            item: (quantity == 0) ? dataJSON.items_removed : dataJSON.items_added
          }
        });

        const orphanAddonKeys = this.getOrphanAddonKeys(dataJSON.items);
        if(orphanAddonKeys.length){
          return this.removeOrphanAddons(orphanAddonKeys);
        }
        this._updateCart(dataJSON.sections);
      }).catch((error) => {
        window.notificationEle.updateNotification('Cart Update', error, {
          type: 'error',
          timeout: 5000
        });
      }).finally(() => {
        setTimeout(() => {
          if(lineItem){ lineItem.classList.remove('updating'); }
        }, 500);
      });
    }
  
    /**
     * Find Customily add-on lines (e.g. engraving) whose parent item is no longer in the cart.
     * Parent items carry `_customily-upsell-main-id`, add-ons carry the matching `_customily-upsell-id`.
     *
     * @param {array} items Cart items from the cart API response
     * @returns {array} Line item keys of orphaned add-ons
     */
    getOrphanAddonKeys(items = []){
      const parentIds = items
        .map(item => item.properties?.['_customily-upsell-main-id'])
        .filter(Boolean);

      return items
        .filter(item => {
          const addonId = item.properties?.['_customily-upsell-id'];
          return addonId && !parentIds.includes(addonId);
        })
        .map(item => item.key);
    }

    /**
     * Remove orphaned add-on lines and refresh the cart HTML
     *
     * @param {array} keys Line item keys to remove
     */
    removeOrphanAddons(keys){
      const updates = keys.reduce((acc, key) => ({ ...acc, [key]: 0 }), {});
      const body = JSON.stringify({
        updates,
        sections: `${this.sectionID},header`
      });

      return fetch(`${routes.cart_update_url}`, { ...Utility.fetchConfig(), ...{ body }})
      .then((response) => response.json())
      .then((dataJSON) => {
        if(dataJSON.errors){
          window.notificationEle.updateNotification('Cart Update', dataJSON.errors, {
            type: 'error',
            timeout: 5000
          });
          return;
        }
        this._updateCart(dataJSON.sections);
      });
    }

    /**
     * Remove Item Event
     */
    removeItem(event){
      event.preventDefault();
      const {currentTarget} = event;
      const itemIndex = currentTarget.dataset.index || null;
      if(itemIndex !== null){
          this.updateItemQty(itemIndex, 0);
      }
    }

    /**
     * Cart Item Qunatity Input change event
     */
    onQtyChange(evt){
      evt.preventDefault();
      const $qtyInput = evt.currentTarget;
      const qtyValue = $qtyInput.value;
      const itemIndex = $qtyInput.dataset.index || null;

      if(itemIndex) this.updateItemQty(itemIndex, qtyValue);
    }
}
customElements.define("cart-form", AjaxCart);